module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-draggable-resizable', {
    staticClass: "ql-selection-cue-marker",
    style: ({
      borderColor: _vm.cueColor(_vm.cue)
    }),
    attrs: {
      "x": _vm.cuePosLeft,
      "y": _vm.cuePosTop,
      "w": _vm.cue.width || 20,
      "h": _vm.cue.height || 20,
      "minw": 10,
      "minh": 10,
      "parent": true,
      "draggable": _vm.editable && !_vm.locked,
      "resizable": _vm.editable && !_vm.locked
    },
    on: {
      "dragging": _vm.onDrag,
      "dragstop": _vm.onDragStop,
      "resizestop": _vm.onResize,
      "activated": _vm.onActivate,
      "deactivated": _vm.onDeactivate
    }
  }, [(!_vm.locked && _vm.editable) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Move or Resize")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5899480e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/cues/cue-selection-marker.vue
// module id = 653
// module chunks = 2